import { render, staticRenderFns } from "./VehicleCardRemarkImages.vue?vue&type=template&id=b46985d2&scoped=true&"
import script from "./VehicleCardRemarkImages.vue?vue&type=script&lang=js&"
export * from "./VehicleCardRemarkImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46985d2",
  null
  
)

export default component.exports